import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

const ELLIPSIS_TYPES = ['circle', 'triangle'] as const;
export type ExclamationShape = (typeof ELLIPSIS_TYPES)[number];

/** Additional input: `direction:'horizontal'|'vertical' = 'horizontal'` for ellipsis direction. */
@Component({
  selector: 'icon-exclamation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './exclamation-icon.component.html',
  styleUrls: ['../styles.scss'],
})
export class ExclamationIconComponent extends BaseIconComponent {
  @Input() set shape(dir: ExclamationShape) {
    this.#shape.next(dir);
  }

  #shape = new BehaviorSubject<ExclamationShape>('triangle');
  shape$ = this.#shape.asObservable();
}
